import { CheckResultModal } from "../../../modal/check_result_modal";
import { BulkStatusModal } from "../../../modal/bulk_status_modal";
import { ConnectModal } from "../../../modal/connect_modal";

/**
 * Показывает модальное окно с результатами проверки статуса
 * @param {Object} data - Результат проверки
 * @returns {Promise<boolean>}
 */
export function showCheckResultModal(data) {
  const modal = new CheckResultModal(data);
  return modal.show();
}

/**
 * Показывает модальное окно смены статуса выбранных номеров
 * @param {number} selectedCount - Количество выбранных номеров
 * @returns {Promise<string | null>}
 */
export function showBulkStatusModal(selectedCount) {
  const modal = new BulkStatusModal(selectedCount);
  return modal.show();
}

/**
 * Показывает модальное окно подключения номеров
 * @param {Object[]} selectedPhones - Выбранные номера
 * @param {number} selectedCount - Количество выбранных номеров
 * @returns {Promise<boolean | null>}
 */
export function showConnectModal(selectedPhones, selectedCount) {
  const modal = new ConnectModal(selectedPhones, selectedCount);
  return modal.show();
}
